import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import axios from 'axios';
import GoogleMapsIcon from '../../../../assets/icons/google_maps.svg'
const API_KEY = 'REMOVE'


const mapStyles = {
  width: '100%',
  padding: '10px',
  height: '200px',
};

export class MapContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coords: null,
      formatedAddress: '',
      showingInfoWindow: false,
      activeMarker: {},
    }
  }

  componentDidMount() {
    if (this.props.address) {
      this.getCoordinatesByAdress(this.props.address)
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.address !== undefined && prevProps.address !== this.props.address) {
      this.getCoordinatesByAdress(this.props.address)
    }
  }
  getCoordinatesByAdress = (address) => {
    axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address.replace(' ', '+')}&key=${API_KEY}`)
      .then(res => {
        const location = res.data.results[0].geometry.location
        const formatedAddress = res.data.results[0].formatted_address;
        this.setState({ coords: location, formatedAddress });
      })
  }
  displayMarkers = () => {
    return <Marker
      position={this.state.coords}
      name={this.state.formatedAddress}
      title={this.state.formatedAddress}
      onClick={this.onMarkerClick} />
  }
  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  onMapClicked = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
      })
    }
  };
  render() {
    if (!this.props.google) {
      return <img src={GoogleMapsIcon} />
    }
    return (
      <div
        style={{
          marginBottom: this.props.height ? parseInt(this.props.height) + 'px' : '200px',
          position: 'relative',
          width: '100%'
        }}>
        {this.state.coords !== null ?
          <Map
            google={this.props.google}
            zoom={this.props.zoom}
            style={{
              ...mapStyles,
              height: this.props.height + 'px',
            }}
            disableDefaultUI={true}
            center={this.state.coords}
          >
            {this.state.coords !== null ? this.displayMarkers() : null}
            <InfoWindow
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}>
              <div>
                <h5>{this.state.formatedAddress}</h5>
                <p></p>
              </div>
            </InfoWindow>
          </Map>
          :
          <Map
            google={this.props.google}
            zoom={this.props.zoom}
            style={{
              ...mapStyles,
              height: this.props.height ? parseInt(this.props.height)  + 'px' : '200px',
            }}
            disableDefaultUI={true}
            initialCenter={{ lat: 59.334591, lng: 18 }}
          >
          </Map>}
      </div>
    );
  }
}
export default GoogleApiWrapper({
  apiKey: API_KEY,

})(MapContainer);